export const LONG_NAMES = 250;
export const LONG_DESCRIPTION = 5000;
export const LONG_NAMES_WIDTH = "50rem";
export const SHORT_NAMES_WIDTH = "25rem";
